import { Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { EventDetailsComponent } from '@calendar/components/event-details/event-details.component';
import { EventFriendsComponent } from '@calendar/components/event-friends/event-friends.component';
import { EventPreviewComponent } from '@calendar/components/event-preview/event-preview.component';
import { AsyncPipe, KeyValuePipe, NgClass, NgForOf, NgIf, NgSwitchCase } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { PaginationComponent } from '@shared-components/pagination/pagination.component';
import { User } from '@models/account/user.model';
import { Database, push, ref, serverTimestamp, set } from '@angular/fire/database';
import { ChatMessage } from '@models/messages/community-message.model';
import SimpleBar from 'simplebar';
import { get } from 'lodash-es';
import { SimplebarAngularModule } from 'simplebar-angular';
import { TimeAgoPipe } from '@pipes/time-ago.pipe';
import { guid } from '@functions/helper.functions';
import { CommonComponent } from '@components/common.component';
import { ApplicationUsersComponent } from '@directory/components/application-users/application-users.component';

@Component({
  selector: 'app-conversation',
  standalone: true,
  imports: [
    EventDetailsComponent,
    EventFriendsComponent,
    EventPreviewComponent,
    NgIf,
    NgSwitchCase,
    AsyncPipe,
    FormsModule,
    NgForOf,
    PaginationComponent,
    NgClass,
    KeyValuePipe,
    SimplebarAngularModule,
    TimeAgoPipe,
    ApplicationUsersComponent,
  ],
  templateUrl: './conversation.component.html',
  styles: ``,
})
export class ConversationComponent extends CommonComponent implements OnInit {
  database = inject(Database);
  @ViewChild('scrollRef') scrollRef!: ElementRef;
  simpleBar: SimpleBar | null = null;
  @Input() data: User | null = null;

  channel: {
    path: string | null;
    receiver: User | null;
    messages?: Record<string, ChatMessage>;
    subscription?: (() => void) | null;
  } | null = null;

  @ViewChild('form') form!: NgForm;
  model: { message: string | null } = { message: null };
  submitted = false;

  ngOnInit() {
    if (this.data) {
      this.onConversation(this.data);
    }
  }

  onConversation(receiver: User) {
    const path = this.role === 'COMMUNITY_RELATIVE' ? '/family' : '/';
    this.router.navigate([path, 'messages'], { queryParams: { key: receiver.id } }).then(() => {
      this.modal.hide();
    });

    /*
    this.channel = null;
    const room =
      'chat_' +
      (receiver.id < this.user!.id
        ? receiver.id + '_' + this.user!.id
        : this.user!.id + '_' + receiver.id);
    this.channel = {
      path: `chat_personal/${room}`,
      receiver,
    };
    const reference = ref(this.database, this.channel!.path!);
    this.channel.subscription = onValue(
      reference,
      (snapshot) => {
        (this.channel!.messages = snapshot.val()), setTimeout(() => this.initSimpleBar());
      },
      { onlyOnce: false },
    );*/
  }

  initSimpleBar() {
    if (!this.simpleBar) {
      const simpleBarRef = get(this.scrollRef, 'SimpleBar');
      if (simpleBarRef) {
        this.simpleBar = simpleBarRef as SimpleBar;
        this.scroll();
      }
    } else {
      this.scroll();
    }
  }

  scroll() {
    this.simpleBar!.getScrollElement()!.scrollTop =
      this.simpleBar!.getScrollElement()!.scrollHeight;
  }

  ngSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      set(
        ref(this.database, `chat_personal_inbox/${this.user!.id}/${this.channel!.receiver!.id}`),
        {
          message: this.model.message!,
          receiverUid: this.channel!.receiver!.id,
          name: `${this.channel!.receiver!.firstName} ${this.channel!.receiver!.lastName}`,
          senderUid: this.user!.id,
          createdAt: serverTimestamp(),
          unread: false,
        },
      ).then();

      set(
        ref(this.database, `chat_personal_inbox/${this.channel!.receiver!.id}/${this.user!.id}`),
        {
          message: this.model.message!,
          receiverUid: this.channel!.receiver!.id,
          name: `${this.user!.firstName} ${this.user!.lastName}`,
          senderUid: this.user!.id,
          createdAt: serverTimestamp(),
          unread: false,
        },
      ).then();

      push(ref(this.database, this.channel!.path!), {
        _id: guid(),
        createdAt: serverTimestamp(),
        pending: false,
        sent: true,
        text: this.model.message!,
        user: {
          _id: this.user!.id,
          name: this.user!.name,
          resident: {
            _id: this.resident!.id,
            name: this.resident!.name,
          },
        },
      }).then(() => {
        this.form.reset();
        this.scroll();
        this.submitted = false;
      });
    }
  }
}
